import { Grid, Hidden } from "@material-ui/core";
import { Fragment, useEffect } from "react";
import { getLS } from "../../../../utils/useLS";
import InvoiceMainOld from "../InvoicesOld";
import RestInvoice from "../InvoiceRest/rest-invoice";
import InvoiceOilMain from "../InvoiceOil/InvoiceOilMain";
import MainInvoiceClass from "./MainInvoiceClass";
import InvoiceRestClass from "../InvoiceRest/InvoiceRestClass";
export default function InvoicesScreen(props) {
  let locR = getLS("DataRem", {});
  const { AutoOptions, isPurches, isStock, isMake, isDialog, invtype, Prctype,
    isOrder,
   orderProceId,  
     orderId,   
   } = props;

  if (Prctype === "02") {
    if (AutoOptions?.permType?.id === 3 && Prctype === "02") {
      return <RestInvoice
        {...{
          AutoOptions,
          isPurches,
          isStock,
          isMake,
          isDialog,
          fromInv: true,

        }}
      />;
    }
    else if (AutoOptions?.permType?.id === 4 ||
       AutoOptions?.permType?.id === 5 && Prctype === "02") {
      return (
        <>
          <InvoiceOilMain
            {...{
              AutoOptions,
              isPurches: invtype == 3 || invtype == 4 || invtype == 6 ? true : false,
              isStock: invtype == 5 || invtype == 7 ? true : false,
              isMake: invtype == 7 ? false : false,
              isDialog: false,
            }}
          />

        </>

      );
    } if (AutoOptions?.permType?.id === 6 && Prctype === "02") {
      return <InvoiceMainOld
        {...{
          AutoOptions,
          isPurches,
          isStock,
          isMake,
          isDialog,
          invtype,
          isOrder: isOrder,
          orderProceId: orderProceId,  
          orderId: orderId,   
        }}
      />;
    }
    else {
      return <MainInvoiceClass
        {...{
          AutoOptions,
          isPurches,
          isStock,
          isMake,
          isDialog,
          invtype,
          isOrder: isOrder,
          orderProceId: orderProceId,  
          orderId: orderId,   
        }}
      />;
    }
  } else {
    return <MainInvoiceClass
      {...{
        AutoOptions,
        isPurches,
        isStock,
        isMake,
        isDialog,
        invtype,
        isOrder: isOrder,
        orderProceId: orderProceId,  
        orderId: orderId,   
      }}
    />;
  }

}
